/**
 * CRO-WEB-178 Experiment Configuration
 *
 * Configuration for the signup form email button experiment.
 * Control: Show the email form fields by default
 * Variant: Show "Continue with Email" button first, then reveal form on click
 */

import type { ExperimentConfig } from "@/src/experiments/useExperimentTracking";
import { getCroWeb178Variant } from "./getCroWeb178Variant";

export const croWeb178Config: ExperimentConfig = {
  name: "cro-web-178",
  getVariant: getCroWeb178Variant,
  eventName: "cro_web_178_experiment_participation",
  featureFlagName: "cro-web-178",
  variants: ["control", "continue-with-email"],
};
